module.exports = __webpack_public_path__ + "static/index/img/baikal-300.638d6f63.jpg";